import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/market'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class MarketCommonApi {


    static async getMarketInfo({ data = { market: undefined }, ...params }) {
        return await fetchService({ url: '/getmarketinfo', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getShopsInfo({ data = { market: undefined }, ...params }) {
        return await fetchService({ url: '/getshopsinfo', method: 'POST', data, notify: { success: false }, ...params })
    }


    static async changeShop({ data = { market: undefined }, ...params }) {
        return await fetchService({ url: '/changeshop', method: 'POST', data, notify: { success: false }, ...params })
    }


    static async changeMarketInfo({ data = { market: undefined, typeComission: undefined, field: undefined, unit: undefined, mapId: undefined, mapField: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changemarketinfo', method: 'PATCH', data, ...params })
    }

}